exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".start{width:100%}.start .navbar-brand{width:199px;padding:10px 15px;margin:auto;float:none;display:block}@media (min-width: 1600px){.start{position:absolute;top:50%;transform:translateY(-50%)}.start .navbar-brand{position:absolute;left:0;right:0;top:-82px}}@media (max-width: 1366px){.start{position:static;transform:none}.start .navbar-brand{margin-bottom:20px;margin-top:20px;position:static}.start .container-box{padding:15px 20px}}@media (max-width: 1280px){.start .container-box{width:100%}}.container-box{background-color:#ffffff;width:990px;margin:auto;padding:40px 25px;box-shadow:0px 2px 2px rgba(0,0,0,0.05);border-radius:3px}.container-box .col-md-7 img{padding:4% 0px;width:75%}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/intro-wizard/intro-wizard.component.scss
// module id = 1355
// module chunks = 7